import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-corelogic-dialog',
  imports: [MatDialogModule],
  templateUrl: './corelogic-dialog.component.html',
  styleUrl: './corelogic-dialog.component.scss',
})
export default class CorelogicDialogComponent {

}
